import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import {
  RoleFindRequest,
  RoleFindResponse,
  RoleFindAllResponse,
  RoleFindAllRequest,
} from '../dto';

export abstract class RoleRepository {
  abstract findAllPath(): string;
  abstract findAll(
    payload?: RoleFindAllRequest,
  ): Observable<HttpResponse<RoleFindAllResponse>>;
  abstract find(payload: RoleFindRequest): Observable<HttpResponse<RoleFindResponse>>;
}


